import React, { FC } from 'react';

import { StyledTabDescriptionTitle } from './styled';

export type TProps = {
    description: string;
};

export const TabDescription: FC<TProps> = ({ description }) => {
    return (
        <>
            <StyledTabDescriptionTitle dangerouslySetInnerHTML={{ __html: description }} />
            {/* Возможно понадобится */}
            {/* <StyledTabDescriptionTitle>{title}</StyledTabDescriptionTitle>
            <StyledabDescriptiontList>
                {list.map((value: string, index: number) => (
                    <StyledabDescriptiontListItem key={index}>{value}</StyledabDescriptiontListItem>
                ))}
            </StyledabDescriptiontList> */}
        </>
    );
};
